import React, { Component, useEffect, useRef, useState } from "react";
import "./App.css";
import { Link, Redirect } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import Axios from "axios";
import validator from "validator";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
// import PhoneInput from "react-phone-number-input";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Customer = () => {
  const history = useHistory();
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [response, setResponse] = useState("");
  const [error, setError] = useState("");
  const [errorDisplay, setErrorDisplay] = useState("none");
  const [spinning, setSpinning] = useState("none");
  const [updateDisplay, setUpdateDisplay] = useState("block");
  const [saveBtn, setSaveBtn] = useState("save-btn");
  const [disabled, setDisabled] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    document.title = "Karamale | Customer registration";
  }, []);

  const onSubmitForm = () => {
    setErrorDisplay("none");
    setUpdateDisplay("none");
    setSpinning("block");
    // Clear existing timeout if any
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (fname.trim() === "" && lname.trim() === "") {
      setError("Please enter first name and surname.");
      setErrorDisplay("block");
      setSpinning("none");
      setUpdateDisplay("block");
    } else if (fname.trim() === "") {
      setError("First name is required");
      setErrorDisplay("block");
      setSpinning("none");
      setUpdateDisplay("block");
    } else if (lname.trim() === "") {
      setError("Surname is required");
      setErrorDisplay("block");
      setSpinning("none");
      setUpdateDisplay("block");
    } else if (email.trim() === "") {
      setError("Enter your email address");
      setErrorDisplay("block");
      setSpinning("none");
      setUpdateDisplay("block");
    } else if (!validator.isEmail(email)) {
      setError("Your email address is invalid");
      setErrorDisplay("block");
      setSpinning("none");
      setUpdateDisplay("block");
    } else if (phone.trim() === "") {
      setError("Enter your phone number");
      setErrorDisplay("block");
      setSpinning("none");
      setUpdateDisplay("block");
    } else if (pass1.length < 8) {
      setError("Password must be at least 8 characters long.");
      setErrorDisplay("block");
      setSpinning("none");
      setUpdateDisplay("block");
    } else if (pass1 !== pass2) {
      setError("Make sure both your passwords match");
      setErrorDisplay("block");
      setSpinning("none");
      setUpdateDisplay("block");
    } else {
      setSaveBtn("btn-disabled");
      setDisabled(true);
      const baseURL = "https://karamale.com/apps/kscanner/webservices.php?";
      const data = new FormData();
      const customername = fname + " " + lname;
      data.append("account_name", customername);
      data.append("phone", phone);
      data.append("email", email);
      data.append("accounttype", "customer");
      data.append("platform", "web");
      data.append("query", "VERIFYACCOUNT");
      Axios({
        method: "POST",
        url: baseURL,
        data: data,
        withCredentials: true,
      })
        .then((response) => {
          if (response.data.status === "success") {
            localStorage.setItem("verificationAccount", "CUSTOMER");
            history.push({
              pathname: "/verification",
              state: {
                email: email,
                accounttype: "customer",
                password: pass1,
              },
            });
          } else {
            setError(response.data.message);
            setErrorDisplay("block");
            setSpinning("none");
            setUpdateDisplay("block");
          }
          setSaveBtn("save-btn");
          setDisabled(false);
        })
        .catch((error) => {
          setSaveBtn("save-btn");
          setDisabled(false);
          alert(error);
        });
    }

    timeoutRef.current = setTimeout(() => {
      setErrorDisplay("none");
    }, 5000);
  };

  return (
    <div className="view">
      {/* <Header /> */}
      <div className="container">
        <div className="row justify-content-center align-content-center login-screen-container w-100">
          <div className="col-lg-5 col-12 align-self-center login-container-adjust pt-5">
            <div className="log-title text-center pt-0">
              <Link to="/">
                <img src="https://karamale.com/karamale.png" width="170" />
              </Link>
            </div>
            <div className=" BoxDashboardContainer">
              <div
                className="col-12 text-left p-0 mb-2"
                style={{ lineHeight: "1rem" }}
              >
                <span>Sign Up to Buy Tickets</span>
                <br />
                <label className="text-12 text-grey">
                  Smart access to events that matter — fast, simple, and secure.
                </label>
              </div>
              <input
                type="text"
                name="first name"
                placeholder="First name"
                value={fname}
                onChange={(e) => setFname(e.target.value)}
              />

              <input
                type="text"
                name="surname"
                placeholder="Surname"
                value={lname}
                onChange={(e) => setLname(e.target.value)}
              />

              <input
                type="text"
                name="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <PhoneInput
                // autoFormat={false}
                disableDropdown={true}
                enableSearch={true}
                showDropdown={false}
                country={"za"}
                value={phone}
                onChange={setPhone}
                inputStyle={{
                  width: "100%",
                  background: "#f0f2f5",
                  height: "2.7em",
                }}
                containerStyle={{ marginBottom: 15 }}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
              />

              <input
                type="password"
                placeholder="New password"
                value={pass1}
                onChange={(e) => setPass1(e.target.value)}
              />

              <input
                type="password"
                placeholder="Confirm password"
                value={pass2}
                onChange={(e) => setPass2(e.target.value)}
              />

              <div className="col-12 response textMedium">{response}</div>
              <div className="">
                <label className="">
                  By signing up, you agree to our{" "}
                  <Link to="/terms-conditions" target={"_blank"}>
                    Ts & Cs.
                  </Link>
                  ,{" "}
                  <Link to="/ticketing-policy" target={"_blank"}>
                    Tcketing Policy
                  </Link>{" "}
                  &{" "}
                  <Link to="/refund-policy" target={"_blank"}>
                    Refund Policy
                  </Link>
                </label>
              </div>
              <button
                onClick={() => onSubmitForm()}
                className={saveBtn + " w-100 mb-3"}
                disabled={disabled}
              >
                <span
                  style={{
                    display: updateDisplay,
                  }}
                >
                  Sign up
                </span>
                <span
                  style={{
                    display: spinning,
                  }}
                >
                  <ClipLoader
                    color={"grey"}
                    loading={true}
                    // css={override}
                    size={20}
                  />
                </span>
              </button>
              <Link to="/login" style={{ textDecoration: "none" }}>
                <div className="text-center cancel-btn">Log in</div>
              </Link>
            </div>

            <div className="text-footer text-center pb-4">
              Buy tickets without pausing{" "}
              <span>
                <Link to={{ pathname: "https://netflix.com" }} target="_blank">
                  <img src="https://karamale.com/netflix1.png" width={70} />
                </Link>
              </span>
              <br />
              That's how easy we make it.
            </div>
          </div>
        </div>
      </div>
      <div
        className="error-login"
        style={{ display: errorDisplay, textAlign: "center" }}
      >
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Customer;
